import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
import LazyLoad from "react-lazyload";  
const SchoolLeavingCertificate = () => {  
  useEffect(() => {
    document.title = 'School Leaving Certificate - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>CBSE Public Disclosure</li>
                    <li>School Leaving Certificate</li>
                </ul>
            </div> 
            <section className="innerbody">
               <div className="container"> 
                    <div className="row">
                    <div className="col-lg-12">
                    <div className="col-lg-12 mand_dis_sec">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/pdf/school-leaving-certificate.jpg" className="img-fluid mx-auto d-block" alt="sfxhisar"/></LazyLoad>
                    </div>
                    </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default SchoolLeavingCertificate;
